export class DocumentType {
  name: string;
  displayName: string;
}
